import { motion } from 'framer-motion';

const StatsCard = ({ icon: Icon, label, value, color, delay = 0, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay, duration: 0.3 }}
    data-testid={`stats-card-${label.toLowerCase().replace(/\s+/g, '-')}`}
    className={`relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#18181b] p-4 sm:p-5 ${className}`}
  >
    <div className="pointer-events-none absolute -right-6 -top-6 h-20 w-20 rounded-full opacity-[0.12]" style={{ backgroundColor: color }} />
    <div className="flex h-9 w-9 items-center justify-center rounded-xl" style={{ backgroundColor: `${color}22` }}>
      <Icon className="h-[18px] w-[18px]" style={{ color }} />
    </div>
    <div className="mt-4 font-heading text-2xl font-semibold tracking-tight text-white tabular sm:text-3xl">{value}</div>
    <div className="mt-0.5 text-xs font-medium text-[#a1a1aa] sm:text-sm">{label}</div>
  </motion.div>
);

export default StatsCard;
